module.exports = __webpack_public_path__ + "img/ИФ-1(А)-034-m.9f4f6387.png";